import React, { Component } from 'react';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input, Dropdown, MenuItem } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import Dropzone from 'react-dropzone';

import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';
import { UI_HEIGHT } from '../Common/constants';
import checkPermission from '../Common/permissions';
import FilterToolbar from '../Common/FilterToolbar';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import ReactPaginate from 'react-paginate';
import generalManagmentModals from '../Common/modals/generalManagement';

const {
  WebUserModal
} = generalManagmentModals;

import {
  isFBD, isCalco,
} from '../../actions/root_url';
import _ from 'lodash';

const isEcity = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';

class RowRenderer extends Component {
  render() {
    // here we are just changing the style
    // but we could replace this with anything we liked, cards, images, etc
    // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (
      <div
        onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}
      >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

class Customers extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      isWebUserModalVisible: false,
      tableHeight: window.innerHeight - UI_HEIGHT.customersPage,

      currentPage: 0,
      limit: isEcity ? null : 25,
      searchFilter: {
        CustomerNum: '',
        Name: '',
        email: '',
        Description: '',
        IsWholesale: '',
        PriceLevel: '',
        IsActive: '',
        MemberCard: '',
        Reseller: '',
        Telephone: '',
        Street: '',
        City: '',
      },
      wholesaleDisplay: <Translate value="all" />,
      activeDisplay: <Translate value="all" />,
      limitDisplay: isEcity ? 'all' : '25',
      rows: [],
      selectedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      files: null,
    };

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    // this.props.fetchCustomers();
    this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // Once customers are ready, reset state.
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.customers && nextProps.customers !== this.props.customers) {
      if(nextProps.currentCustomer) {
        this.setState({
          selectedRows: nextProps.customers
            .filter(customer => customer.Customer_id === this.props.currentCustomer.Customer_id)
            .map(customer => ({...customer, isSelected: true})),
        });
      }
      const currentCustomerId = this.props.currentCustomer ? this.props.currentCustomer.Customer_id : null;
      this.setState({
        rows: nextProps.customers.map(customer => ({...customer, isSelected: customer.Customer_id === currentCustomerId})),
      });
    }
    
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.customersPage });
  }

  onDrop(files) {
    if (files) {
      alert('Upload takes time, please stay on the current page');
    }
    this.props.attachDocument(files);
    this.setState({
      files,
    });
  }

  // Helper function to render an icon for the stock statues of customer.
  renderIsActive(isActive) {
    if (isActive) { return <span className="label label-success"><Translate value="active" /></span>; }
    return <span className="label label-danger"><Translate value="inactive" /></span>
  }

  renderIsWholesale(isWholeSale) {
    if (isWholeSale) { return <span className="label label-success"><Translate value="yes" /></span>; }
    return (<span className="label label-danger"><Translate value="no" /></span>);
  }

  // Set customer being selected to be currentCustomer and navigate user to the edit page
  setCurrentCustomer(e) {
    e.preventDefault();
    const currentCustomer = this.state.selectedRows[0];
    const customerFromOriginalData = this.props.customers.filter(customer => customer.Customer_id === currentCustomer.Customer_id)[0];
    this.props.resetCurrentCustomer();
    this.props.selectCustomer(customerFromOriginalData);
    this.context.router.push('/customers/' + customerFromOriginalData.Customer_id);
  }

  // Reset the currentCustomer and navigate to the create page
  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentCustomer();
    this.context.router.push('/customers/new');
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderTable() {
    if (this.props.isLoading && !this.props.error) {
      return (
        <ContentWrapper>
          <br />
          <Spinner />
        </ContentWrapper>
      );
    } else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
        </ContentWrapper>
      );
    }

    const modifiedRows = this.state.rows.map((customer) => {
      return {
        ...customer,
        IsActive: customer.IsActive ? 'active' : 'inactive',
        IsWholesale: customer.IsWholesale ? 'yes' : 'no',
      };
    });

    const getRows = () => {
      const data = {
        ...this.state,
        rows: modifiedRows,
      };
      return Data.Selectors.getRows(data);
    };

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    // Custom Formatter component
    const IsActiveFormatter = React.createClass({
      render() {
        if (this.props.value === 'active') { return <span className="label label-success"><Translate value="active" /></span>; }
        return <span className="label label-danger"><Translate value="inactive" /></span>;
      },
    });

    const IsWholesaleFormatter = React.createClass({
      render() {
        if (this.props.value === 'yes') { return <span className="label label-success"><Translate value="yes" /></span>; }
        return <span className="label label-danger"><Translate value="no" /></span>;
      },
    });

    // Handle the row select function
    const onRowSelect = (rows) => {
      this.setState({ selectedRows: rows });
    };

    const onRowsSelected = (rows) => {
      let newRows = [...this.state.rows];
      let selectedRows = this.state.selectedRows;

      newRows.map((r) => {
        r.isSelected = false;
      });

      selectedRows = [];
      rows.map((row) => {
        let index = _.findIndex(this.state.rows, { 'Customer_id': row.row.Customer_id })
        newRows[index].isSelected = true;
        selectedRows.push(row.row);
      });

      this.setState({ rows: newRows, selectedRows, selectedRowsIdx: rows[0].rowIdx });
    };

    const onRowsDeselected = (rows) => {
      let newRows = [...this.state.rows];
      rows.map((row) => {
        let index = _.findIndex(this.state.rows, { 'Customer_id': row.row.Customer_id })
        newRows[index].isSelected = false;
      });
      let selectedRows = [];
      newRows.map((r) => {
        if (r.isSelected) { selectedRows.push(r); }
      })
      this.setState({ rows: newRows, selectedRows });
    };

    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    // Column difinition
    const columns = [
      {
        key: 'CustomerNum',
        name: <Translate value="customer_no" />,
        width: 130,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      ...isCalco ? [{
        key: 'Route_id',
        name: <Translate value="route_id" />,
        width: 100,
        resizable: true,
        sortable: true,
        filterable: true,
      }] : [],
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: 'Telephone',
        name: <Translate value="phone" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      {
        key: 'Street',
        name: <Translate value="address" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 190,
      },
      ...isEcity ? [{
        key: 'City',
        name: <Translate value="city" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }] : [{
        key: 'email',
        name: <Translate value="email" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      }],
      {
        key: 'Description',
        name: <Translate value="description" />,
        width: 200,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'IsWholesale',
        name: <Translate value="wholesale" />,
        width: 100,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: IsWholesaleFormatter,
      },
      {
        key: 'PriceLevel',
        name: <Translate value="price_lvl" />,
        width: 90,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'IsActive',
        name: <Translate value="active" />,
        width: 80,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: IsActiveFormatter,
      },
    ];

    if (isEcity) {
      const indexDescription = _.findIndex(columns, { key: 'Description' });
      const memberCardColumn = {
        key: 'MemberCard',
        name: <Translate value="member_card" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      };
      const resellerColumn = {
        key: 'Reseller',
        name: <Translate value="reseller" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      };
      columns.splice(indexDescription, 0, resellerColumn);
      columns.splice(indexDescription, 0, memberCardColumn);
    }

    return (
      // React Table Customers
      <div>
        <Row>
          <Col md={12}>
            <div id="Customers-dataGrid1" style={{ marginTop: '80px' }}>
              <ReactDataGrid
                rowRenderer={
                  <RowRenderer
                    onDoubleClick={(customerFromOriginalData) => {
                      this.props.resetCurrentCustomer();
                      this.props.selectCustomer(customerFromOriginalData);
                      this.context.router.push('/customers/' + customerFromOriginalData.Customer_id);
                    }}
                  />
                }
                rowKey="Customer_id"
                enableCellSelect={true}
                onGridSort={handleGridSort}
                // toolbar={<FilterToolbar enableFilter />}
                // onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={this.state.tableHeight - 95}
                enableRowSelect="single"
                onRowUpdated={this.handleRowUpdated}
                onRowSelect={onRowSelect}
                minColumnWidth={300}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} >
            <div style={{ width: '630px' }} id="react-pagination">
              <ReactPaginate
                previousLabel={<Translate value="prev_page" />}
                nextLabel={<Translate value="next_page" />}
                containerClassName={'pagination'}
                activeClassName={'active'}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                pageCount={this.props.customerTotalPages}
                onPageChange={handleOnPageChange}
                forcePage={this.state.currentPage}
              />
            </div>
          </Col>
        </Row>
        <Row style={{ padding: '10px', paddingTop: '0px', fontSize: 'small' }}>
          <label>
            <Translate value="total_customers" />:&nbsp;
            <span className="font-color-orange">{this.props.customerTotalCount}</span>
          </label>
        </Row>
      </div>
    );
  }

  renderSearchFilter() {
    const isWholesaleSelection = [
      {
        label: <Translate value="all" />,
        value: '',
        name: 'IsWholesale',
      },
      {
        label: <Translate value="yes" />,
        value: '1',
        name: 'IsWholesale',
      },
      {
        label: <Translate value="no" />,
        value: '0',
        name: 'IsWholesale',
      },
    ]

    const isActiveSelection = [
      {
        label: <Translate value="all" />,
        value: '',
        name: 'IsActive',
      },
      {
        label: <Translate value="active" />,
        value: '1',
        name: 'IsActive',
      },
      {
        label: <Translate value="inactive" />,
        value: '0',
        name: 'IsActive',
      },
    ]

    const limitSelection = [
      {
        label: '25',
        value: 25,
        name: 'limit',
      },
      {
        label: '50',
        value: 50,
        name: 'limit',
      },
      {
        label: '100',
        value: 100,
        name: 'limit',
      },
      {
        label: <Translate value="all" />,
        value: null,
        name: 'limit',
      },
    ]

    const handleOnSubmit = (event) => {
      event.preventDefault();
    }

    const handleFilterChange = (event) => {
      this.state.currentPage = 0;
      let keys = Object.keys(this.state.searchFilter);
      for (let i = 0; i < keys.length; i++) {
        if (event.target.name === keys[i]) {
          this.state.searchFilter[keys[i]] = event.target.value;
        }
      }
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const handleFilterChangeDropdown = (el) => {
      this.state.currentPage = 0;
      let keys = Object.keys(this.state.searchFilter);
      for (let i = 0; i < keys.length; i++) {
        if (el.name === keys[i]) {
          this.state.searchFilter[keys[i]] = el.value;
          if (el.name === 'IsWholesale') {
            this.state.wholesaleDisplay = el.label;
          } else if (el.name === 'IsActive') {
            this.state.activeDisplay = el.label;
          }
        }
      }
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    return (
      <div style={{ width: '1400px' }}>
        <Row>
          <Col md={12}>
            <div className="form-group" style={{ marginBottom: '0px', marginTop: '30px', position: 'absolute', zIndex: 2 }} id="search-product-by">
              <form autoComplete='off' onSubmit={handleOnSubmit}>
                <Row>
                  <Col>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="customer_no" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="name" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="phone" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="address" /></label>
                    {isEcity && <label className="col-sm-3" style={{ width: '120px' }}><Translate value="city" /></label>}
                    {!isEcity && <label className="col-sm-3" style={{ width: '120px' }}><Translate value="email" /></label>}
                    {isEcity && <label className="col-sm-3" style={{ width: '120px' }}><Translate value="member_card" /></label>}
                    {isEcity && <label className="col-sm-3" style={{ width: '120px' }}><Translate value="reseller" /></label>}
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="description" /></label>
                    <label className="col-sm-3" style={{ width: '90px' }}><Translate value="wholesale" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="price_lvl" /></label>
                    <label className="col-sm-3" style={{ width: '115px' }}><Translate value="active" /></label>
                    <label className="col-sm-3" style={{ width: '90px' }}><Translate value="limit" /></label>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="CustomerNum" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="Name" type="text" onChange={handleFilterChange} />
                  </Col>

                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="Telephone" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="Street" type="text" onChange={handleFilterChange} />
                  </Col>
                  {
                    isEcity ? (
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="City" type="text" onChange={handleFilterChange} />
                      </Col>
                    ) : (
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="email" type="text" onChange={handleFilterChange} />
                      </Col>
                    )
                  }
                  {
                    isEcity &&
                    <Col className="col-sm-3" style={{ width: '120px' }} >
                      <Input name="MemberCard" type="text" onChange={handleFilterChange} />
                    </Col>
                  }
                  {
                    isEcity &&
                    <Col className="col-sm-3" style={{ width: '120px' }} >
                      <Input name="Reseller" type="text" onChange={handleFilterChange} />
                    </Col>
                  }
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="Description" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '90px' }} >
                    <Dropdown>
                      <Dropdown.Toggle style={{ width: '75px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                        {this.state.wholesaleDisplay}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="super-colors">
                        {isWholesaleSelection.map(el => {
                          return (
                            <MenuItem onClick={() => handleFilterChangeDropdown(el)}>{el.label}</MenuItem>
                          )
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="PriceLevel" type="number" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '115px' }} >
                    <Dropdown>
                      <Dropdown.Toggle style={{ width: '100px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                        {this.state.activeDisplay}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="super-colors">
                        {isActiveSelection.map(el => {
                          return (
                            <MenuItem onClick={() => handleFilterChangeDropdown(el)}>{el.label}</MenuItem>
                          )
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>

                  <Col className="col-sm-3" style={{ width: '90px' }} >
                    <Dropdown>
                      <Dropdown.Toggle style={{ width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                        {this.state.limitDisplay}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="super-colors">
                        {limitSelection.map(el => {
                          return (
                            <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                          )
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  setWebUserModalVisibility = (isWebUserModalVisible = false) => this.setState({ isWebUserModalVisible })

  render() {
    const height = (this.state.tableHeight + 70).toString();
    const tableCollapseFix = { height };
    const token = localStorage.getItem('token');
    const excelUrl = `${ROOT_URL}v1/customer/export/?Bearer=${localStorage.getItem('token')}`;
    const memberCardURL = this.state.selectedRows.length && `${ROOT_URL}v1/customer/print_member/${this.state.selectedRows[0].Customer_id}?Bearer=${token}`;
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="customers" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* Nav Trail */}

        <Grid fluid="true" id="customers-page">
          <h1><Translate value="manage_customers" /></h1>
          <Row>
            <Col xs={12}>
              <Panel className="position-relative mb0" style={tableCollapseFix}>
                <ButtonToolbar className="table-buttons" style={{ display: 'flex' }}>
                  <Button
                    bsStyle="success"
                    type="submit"
                    onClick={(event) => { this.clickNew(event); }}
                    disabled={!checkPermission('add_customer')}
                  >
                    <em className="fa fa-plus" /><Translate value="add" />
                  </Button>
                  <Button
                    bsStyle="warning"
                    type="button"
                    onClick={(event) => { this.setCurrentCustomer(event); }}
                    disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !checkPermission('change_customer')}
                  >
                    <em className="fa fa-pencil" /><Translate value="edit" />
                  </Button>
                  <Button
                    bsStyle="success"
                    type="button"
                    href={excelUrl}
                  >
                    <em className="fa fa-download" /><Translate value="export" />
                  </Button>
                  <Dropzone onDrop={this.onDrop.bind(this)} style={{ 'padding-left': '5px' }} className="upload-button">
                    <Button bsStyle="primary" disabled={!checkPermission('add_customer') || this.props.isAttachingDocument}>
                      <em className={`fa ${this.props.isAttachingDocument ? 'fa-spinner fa-spin' : 'fa-file-text'}`} />
                      <Translate value="upload_import" /> (CSV)
                    </Button>
                  </Dropzone>
                  {
                    isFBD && (
                      <Button
                        bsStyle="success"
                        type="button"
                        // href={excelUrl}
                        disabled={this.state.selectedRows.length !== 1}
                        onClick={() => {
                          this.setWebUserModalVisibility(true);
                        }}
                      >
                        <em className="fa fa-user" /><Translate value="create_web_user" />
                      </Button>
                    )
                  }
                  {
                    isEcity && (
                      <Button
                        bsStyle="success"
                        type="button"
                        href={memberCardURL}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1}
                      >
                        <em className="fa fa-download" /><Translate value="member_card" />
                      </Button>
                    )
                  }
                </ButtonToolbar>
                {/* Customers Table */}
                {this.renderSearchFilter()}
                {this.renderTable()}
              </Panel>
            </Col>
          </Row>
        </Grid>
        <WebUserModal 
          isVisible={this.state.isWebUserModalVisible}
          setModalVisibility={this.setWebUserModalVisibility}
          selectedRows={this.state.selectedRows}
        />
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default Customers;



// WEBPACK FOOTER //
// ./master/jsx/components/Customers/customers.jsx